import React from "react";
import { Typography } from "@material-ui/core";
import { classes } from "../api/constants";
import axios from "axios";
import {LinearProgress} from "@material-ui/core";


const TRADEMARK_DETAIL_URL = "https://api2.mecrazy1.repl.co/tm_detail/";



const getData = (e) => {
  //console.log(e.target);
  
  e.target.innerHTML='<strong>Fetching Data...</strong>'
  e.target.disabled=true
  var url = e.target.getAttribute("data-url");
  var view_state = e.target.getAttribute("data-view_state");
  var event_validation = e.target.getAttribute("data-event_validation");
  var more_details_event_target = e.target.getAttribute("data-more_details_event_target");
  
  
  var postData = {
    url: url,
    view_state: view_state,
    event_validation: event_validation,
    more_details_event_target:  more_details_event_target,
  };
  
  axios.post(TRADEMARK_DETAIL_URL,postData)
            .then(res => {
              //console.log(res.data)
              var parent =e.target.parentNode
              parent.querySelector('button').remove()
              Object.keys(res.data).forEach((key,index)=>{
                var pClass = key.split(' ')[0]
                var p = parent.querySelector('p.'+pClass)
                //console.log(p)
                 //console.log(parent)
                var span = p.querySelector('span')
                span.append(key+' : ')
                p.append(res.data[key])
              })
            })

  //alert(url)
  //console.log('ok doning',url)
  //alert(url)
  //var parent =e.target.parentNode
  //parent.querySelector('button').remove()
  //var p =parent.querySelector('p.Extra').querySelector('span')
  var g = "Hello";
  //p.append(g)
  //parent.append('SomeMoreData:valide')
  //console.log(trademark);
  //return [g]
};

const TMSearchResultItem = ({ trademark, openDetail }) => {
  return (
    <div className="p-4 flex flex-col sm:flex-row">
      <div className="flex-1">
        <h1 className="text-lg font-medium">{trademark.wordmark}</h1>
        <p>
          <span className="font-medium">Class :</span> {trademark.class}
        </p>
        <p>
          <span className="font-medium">Status : </span>
          {trademark.status}
        </p>
        <p>
          <span className="font-medium">Application Number : </span>
          {trademark.application_number}
        </p>
        {/*<p><span className="font-medium">Application Date : </span>{trademark.application_date}</p>
                <p><span className="font-medium">Used Since : </span>{trademark.used_since}</p>
                <p><span className="font-medium">Valid Upto : </span>{trademark.valid_upto}</p>*/}
        <p>
          <span className="font-medium">Appplicant Name : </span>
          {trademark.proprietor}
        </p>
        <p class="Application">
          <span className="font-medium"></span>
        </p>
        <p class="Journal">
          <span className="font-medium"></span>
        </p>
        <p class="Journal">
          <span className="font-medium"></span>
        </p>
        <p class="Used">
          <span className="font-medium"></span>
        </p>
        <p class="Valid">
          <span className="font-medium"></span>
        </p>
        <p class="Goods">
          <span className="font-medium"></span>
        </p>
        {/*<p><span className="font-medium"> Journal Date : </span>{trademark.journal_date}</p>
         */}
         <button class='p-2 text-white rounded-lg mt-2 mb-2' style={{ backgroundColor: '#AB5212' }}
          data-url={trademark.extra.url}
          data-view_state={trademark.extra.view_state}
          data-event_validation={trademark.extra.event_validation}
          data-more_details_event_target={
            trademark.extra.more_details_event_target
          }
          onClick={getData}
        >
           Get More details..
        </button>
        {/*<button class="relative rounded px-5 py-2.5 overflow-hidden group bg-orange-750 relative hover:bg-gradient-to-r hover:from-orange-500 hover:to-green-400 text-white hover:ring-2 hover:ring-offset-2 hover:ring-green-400 transition-all ease-out duration-300 mb-2 mt-2">
<span class="absolute right-0 w-8 h-32 -mt-12 transition-all duration-1000 transform translate-x-12 bg-white opacity-10 rotate-12 group-hover:-translate-x-40 ease"></span>
<span class="relative">Button Text</span>
</button>*/}
      </div>

      <div className="sm:ml-8">
        {trademark.image ? (
          <img src={trademark.image} className="h-32 w-32" />
        ) : (
          <p className="h-32 w-32 text-gray-400 text-center justify-center">
            No Image
          </p>
        )}
      </div>
      
    </div>
    
  );
};

export default TMSearchResultItem;
